import { get,post, del, put } from "@/plugin/newAxios";
export default {
  install(Vue, options) {
    Vue.prototype.changeGoodsName = function (goodsName) {
      if (goodsName == '0110001') {
        return '褐煤';
      }
      if (goodsName == '0110002') {
        return '炼焦烟煤';
      }
      if (goodsName == '0110003') {
        return '无烟煤';
      }
      if (goodsName == '0110004') {
        return '一般烟媒';
      }
      if (goodsName == '0110005') {
        return '原煤';
      }
      if (goodsName == '0110006') {
        return '烟煤';
      }
      if (goodsName == '0120001') {
        return '炼焦精煤';
      }
      if (goodsName == '0120002') {
        return '洗精煤';
      }
      if (goodsName == '0130001') {
        return '褐块煤';
      }
      if (goodsName == '0130002') {
        return '块煤';
      }

      if (goodsName == '0130003') {
        return '筛选块煤';
      }
      if (goodsName == '0130004') {
        return '无烟块煤';
      }
      if (goodsName == '0130005') {
        return '洗块煤';
      }
      if (goodsName == '0130006') {
        return '烟块煤';
      }
      if (goodsName == '0140001') {
        return '粉煤';
      }
      if (goodsName == '0140002') {
        return '末煤';
      }
      if (goodsName == '0140003') {
        return '煤泥';
      }
      if (goodsName == '0140004') {
        return '筛选粉煤';
      }
      if (goodsName == '0140005') {
        return '筛选混煤';
      }
      if (goodsName == '0140006') {
        return '筛选煤';
      }

      if (goodsName == '0140007') {
        return '筛选末煤';
      }
      if (goodsName == '0140008') {
        return '洗粉煤';
      }
      if (goodsName == '0140009') {
        return '洗混煤';
      }
      if (goodsName == '0140010') {
        return '洗煤';
      }
      if (goodsName == '0140011') {
        return '洗末煤';
      }
      if (goodsName == '0140012') {
        return '洗选煤';
      }
      if (goodsName == '0140013') {
        return '洗原煤';
      }
      if (goodsName == '0140014') {
        return '洗中煤';
      }
      if (goodsName == '0150001') {
        return '水煤浆';
      }
      if (goodsName == '0190001') {
        return '风化煤';
      }

      if (goodsName == '0190002') {
        return '蜂窝煤';
      }
      if (goodsName == '0190004') {
        return '红煤粉';
      }
      if (goodsName == '0190005') {
        return '煤饼';
      }
      if (goodsName == '0190006') {
        return '煤粉';
      }
      if (goodsName == '0190007') {
        return '煤球';
      }
      if (goodsName == '0190008') {
        return '煤砖';
      }
      if (goodsName == '0190009') {
        return '煤制品';
      }
    };
    //查询起始站
    Vue.prototype.searchStartStations = function (vm, callback) {
      vm.$axios.post('RailwayStartStationQry.do').then(data => {
        if (data) {
          callback(data.RespMap.list)
        }
      }).catch(error => {
      })
    }
    //根据起始站返回终点站
    Vue.prototype.searchEndByStart = function (vm, startStation, callback) {
      vm.$axios.post('RailwayEndStationQry.do', startStation).then(data => {
        if (data) {
          callback(data.RespMap.list)
        }
      }).catch(error => {

      })
    }
    //RailwayAllEndStationQry  查询所有终点站
    Vue.prototype.searchAllEndStations = function (vm, callback) {
      vm.$axios.post('RailwayAllEndStationQry.do').then(data => {
        if (data) {
          callback(data.RespMap.list)
        }
      }).catch(error => {

      })
    }
    //RailwayStartStationByEndQry  根据终点查询起点
    Vue.prototype.searchStartByEnd = function (vm, startStation, callback) {
      vm.$axios.post('RailwayStartStationByEndQry.do').then(data => {
        if (data) {
          callback(data.RespMap.list)
        }
      }).catch(error => {

      })
    }
    //发到站模糊查询
    //RailwayStationsQry 发到站总接口
    Vue.prototype.departureStation = function (vm, callback) {
      post('/ysfw/v1/jzx/RailwayStationsQryByLanguage').then(data => {
        if (data) {
          callback(data.RespMap.list)
        }
      }).catch(error => {

      })
    }
    Vue.prototype.filterMethod = function (vm, query, selceList, stationList) {
      if (query !== '') {
        vm[selceList] = vm[stationList].filter(item => {
          return item.stationsName.indexOf(query) > -1 || item.stationsSpell.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        vm[selceList] = vm[stationList];
      }
    }
  }
};
